<template>
  <div v-if="$page" id="page-contact">
    <header class="header -contact">
      <figure v-scroll:parallax="{ ratio: 0.15 }" class="header__background -darken">
        <Image v-if="$page.headerImg" :source="$page.headerImg" />
      </figure>

      <div class="header__content">
        <h1 v-scroll:reveal="{ delay: 550 }" class="header__legend">{{ $page.title }}</h1>
        <h2 v-scroll:reveal="{ delay: 600 }" class="header__title">{{ $page.headerTitleTop }}</h2>
        <h3 v-scroll:reveal="{ delay: 650 }" class="header__title">
          {{ $page.headerTitleBottom }}
        </h3>
      </div>

      <div v-if="$beet.options.businessInfos" class="header__card">
        <h3 class="header__card-title">{{ $beet.options.businessInfos.businessName }}</h3>
        <address class="header__card-address">
          {{
            `${$beet.options.businessInfos.addressLine1}\n${$beet.options.businessInfos.addressLine2}`
          }}
        </address>
        <p class="header__card-phone">{{ $beet.options.businessInfos.phoneNumber }}</p>

        <a
          :href="$beet.options.businessInfos.getDirectionsUrl"
          target="_blank"
          rel="noopener"
          class="header__card-link"
        >
          <Icon id="arrow" />
          {{ $page.headerCardDirectionsLabel }}
        </a>

        <LangRouterLink
          :to="{ name: 'contact', hash: '#map' }"
          class="button -border -link -full-width"
          >{{ $page.headerCardButtonLabel }}
        </LangRouterLink>
      </div>
    </header>

    <ContactForm
      :legend="$page.contactFormLegend"
      :title="$page.contactFormTitle"
      :text="$page.contactFormText"
    />

    <LocationMap :legend="$page.locationLegend" :title="$page.locationTitle" />
  </div>
</template>

<script>
import ContactForm from '@/components/forms/ContactForm.vue'
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import LocationMap from '@/components/sections/LocationMap.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Contact',
  beetPage: 'contact',
  mixins: [PageMetaMixin],
  components: { ContactForm, Icon, Image, LangRouterLink, LocationMap },
}
</script>
